"use client";
import { CurrencyConverter } from "@/lib/constants";
import { Stack, Typography } from "@mui/material";
import { PaperComponent, SliderComponent } from "@/components";
import { useTranslations } from "use-intl";

const OfferSelectionHeader = ({
  offerData,
  selectedItem,
  amount,
  handleSliderClculation,
}) => {
  const t = useTranslations("offers.offerselection");
  const minAmount = offerData?.offers?.find(
    (item) => item?.offerType === "APPLIED",
  )?.amount;

  /*******************************ACTION*******************************/
  const handleChange = (_, newValue) => {
    handleSliderClculation(newValue);
  };

  /*******************************RENDER*******************************/
  return (
    <>
      {selectedItem?.slider && minAmount !== selectedItem?.amount ? (
        <Typography variant="h5">{t("tittle1")}</Typography>
      ) : (
        <Typography variant="h5">{t("tittle2")}</Typography>
      )}
      <PaperComponent>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography variant="h6">{t("loanamount")}</Typography>
          <Typography variant="h6" fontWeight="bold">
            {selectedItem?.offerType === "RECOMMENDED" || selectedItem?.slider
              ? `${CurrencyConverter(amount)}`
              : `${CurrencyConverter(selectedItem?.amount)}`}
          </Typography>
        </Stack>
        <SliderComponent
          max={selectedItem?.amount}
          amountRequired={selectedItem?.slider}
          min={minAmount}
          value={amount}
          onChange={handleChange}
          step={10000}
        />
      </PaperComponent>
    </>
  );
};

export default OfferSelectionHeader;
